// Per-browser display identity. No accounts in v1 — just a name + color kept in
// localStorage so a student keeps the same color across rooms and reloads.
const KEY = 'collabmap.identity'
const USER_ID_KEY = 'collabmap.userId'

// Stable, per-browser random id. Survives name changes, so feature ownership
// ("only you can edit your own shapes") isn't spoofable just by picking the
// same display name. Not real auth — good enough for a classroom.
export function ensureUserId() {
  try {
    let id = localStorage.getItem(USER_ID_KEY)
    if (!id) {
      id = crypto.randomUUID()
      localStorage.setItem(USER_ID_KEY, id)
    }
    return id
  } catch {
    // Storage unavailable (private mode) — a per-session id is the best we can do.
    if (!window.__collabmapSessionId) window.__collabmapSessionId = crypto.randomUUID()
    return window.__collabmapSessionId
  }
}

// Distinct, high-contrast colors that read well as cursors and feature strokes
// on both street and satellite basemaps.
export const PALETTE = [
  '#ef4444', '#f97316', '#f59e0b', '#eab308',
  '#84cc16', '#22c55e', '#10b981', '#14b8a6',
  '#06b6d4', '#3b82f6', '#6366f1', '#8b5cf6',
  '#a855f7', '#d946ef', '#ec4899', '#f43f5e',
]

export function randomColor() {
  return PALETTE[Math.floor(Math.random() * PALETTE.length)]
}

export function loadIdentity() {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (parsed && typeof parsed.name === 'string' && typeof parsed.color === 'string') {
      return parsed
    }
  } catch {
    /* ignore corrupt storage */
  }
  return null
}

export function saveIdentity(identity) {
  try {
    localStorage.setItem(KEY, JSON.stringify(identity))
  } catch {
    /* storage may be unavailable (private mode) — non-fatal */
  }
}
